export const ROOT = '/'

export const NOT_FOUND = `${ROOT}not-found`

export const EXPERTISE = `${ROOT}expertise`
export const COMPANY = `${ROOT}company`
export const CONTACT = `${ROOT}contact`
export const FAQ = `${ROOT}faq`
export const CALCULATOR = `${ROOT}calculator`
export const BLUEPRINT = `${ROOT}blueprint`
export const BLOCKCHAIN = `${ROOT}blockchain`
export const CTO = `${ROOT}cto`
export const PRIVACY_POLICY = `${ROOT}privacy-policy`
export const TERMS_CONDITIONS = `${ROOT}terms-conditions`

export const WORK = `${ROOT}work`
export const PROJECT = (id: string) => `${WORK}/${id}`

export const BLOG = `${ROOT}blog`
export const BLOG_POST = (id: string) => `${BLOG}/${id}`
